import { FC, useRef, useState } from 'react';

import styles from './VideoGuide.module.sass';

const SRC = 'https://amlbot.com/video/ai-tracer/guide.mp4#t=0.1';

const VideoGuide: FC = () => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleToggle = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      void video.play();
    } else {
      video.pause();
    }
  };

  return (
    <div className={styles.wrapper}>
      <video
        ref={videoRef}
        className={styles.video}
        src={SRC}
        muted
        playsInline
        preload="metadata"
        onClick={handleToggle}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      />

      <button
        type="button"
        className={`${styles.control} ${isPlaying ? styles.playing : ''}`}
        onClick={handleToggle}
        aria-label={isPlaying ? 'Pause video' : 'Play video'}
      >
        {isPlaying ? (
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="6" y="5" width="4" height="14" rx="1" />
            <rect x="14" y="5" width="4" height="14" rx="1" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5.5c0-.8.87-1.29 1.55-.88l9.1 5.5a1.03 1.03 0 0 1 0 1.76l-9.1 5.5c-.68.41-1.55-.08-1.55-.88V5.5Z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default VideoGuide;
